import { Banner } from '@shopify/polaris';

export function ActionBanner({
  tone = 'info',
  title,
  children,
}: {
  tone?: any;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Banner tone={tone} title={title}>
      <div>{children}</div>
    </Banner>
  );
}
